<template>
  <div class="mit-equipment-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>My Events
              <div class="spacer"></div>
              <v-tooltip bottom max-width="300px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" color="primary" target="_blank" :href="`${siteUrl}/csail_login`"><i class="v-icon notranslate pr-2 mdi mdi-calendar-plus theme--light"></i>NEW EVENT<v-icon class="mx-5" small> mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>Login to CSAIL to add an event. <br />"Create Event" button is on the left bottom corner of your CSAIL profile.</span>
              </v-tooltip>
            </v-card-title>
            <v-card-subtitle class="caption">Upcoming Events</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
              <template>
                <BaseMitLoading :show="loading" :overlayFullscreen="false"/>
                <span v-for="(event, index) in events" :key="index" >
                  <template v-if="userModel.csailId === event.uid">
                    {{ myevents = null }} 
                    <p class="eventbox">
                    <strong>{{ event.field_start_date_1 }}</strong><br />
                    {{ event.field_start_date }} - {{ event.field_end_date }}<br />
                    <a :href="event.view_node">{{ event.title }}</a><br />
                    Location: {{ event.field_room_location }}<br />
                    <span v-if="event.field_cancelled=='Yes'" class="textred">Cancelled!</span></p>
                  </template>
                </span>
              </template>
              <template >
                <p v-if="myevents">You have no upcoming events.</p>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import axios from 'axios';
  import BaseMitConfigService from '../../base/services/BaseMitConfigService.js';
  import BaseMitLoading from '../../base/components/BaseMitLoading.vue';

  export default {
    name: 'MitMyEventsPage',
    data() {
      return {
        events: [],
        myevents: true,
        loading:true,
        siteUrl:null,
        eventsUrl:null
      };
    },
    components: {
      BaseMitLoading
    },
    created() {
      this.siteUrl = BaseMitConfigService.get('CLIENT_API_EVENTS');
      this.eventsUrl = this.siteUrl+"/api/userevents?="+new Date().getTime();
    },
    mounted() {
      this.fetchEvents();
    },
    props: {
        userModel: Object, //comes from route
        // userRoles: Object //comes from route
    },
    methods: {
      fetchEvents() {
        this.loading = true;
        axios.get(this.eventsUrl) 
          .then(response => {
            this.loading = false;
            this.events = response.data;
          })
          .catch(error => {
            this.loading = false;
            console.error('Error fetching events:', error);
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
  .eventbox {
    background-color: #efefef;
    border-radius: 2px;
    padding: 20px;
  }
  .textred {
    color:red;
  }
</style>
